<template>
    <div  class="enquiry-banner">
        <div class="enquiry-banner__card">
            <div class="enquiry-banner__card--image"></div>
            <div class="enquiry-banner__card--text">
                <h1 class="enquiry-banner__card--header">Can't find the role you're looking?</h1>
                <h3 class="enquiry-banner__card--subheading">Register your interest and receive job updates when the right vacancy for you becomes available</h3>
                <button @click="RegisterInterest" class="link link--is-button link--has-icon">Register interest</button>
            </div>
        </div>
        <register-interest-modal @closeModal="closeModal" :modalOpen="modalOpen" :user="user" :business_areas="business_areas" :privacy_policy_url="privacy_policy_url" :terms_url="terms_url" ></register-interest-modal>
    </div>
</template>

<script>
import RegisterInterestModal from '../components/RegisterInterestModal.vue';
export default {
    props:[
        'business_areas',
        'privacy_policy_url',
        'terms_url'
    ],
    components: {
       RegisterInterestModal,
    },
    data() {
        return {
            modalOpen: false,
            modalData: null,
            user:{
              businessArea: "",
            }
        };
    },
    computed: {

    },
    methods: {
        RegisterInterest(){
            this.modalOpen = true;
        },

        closeModal() {
            this.modalOpen = false;
        },
    },
    mounted() {
        
    },
    beforeDestroy() {

    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/careers/components/Banner.vue